/* Bisou Rivage — Wishlist globale (localStorage, sans compte)
   Clé : br_wishlist_v1 — { v:1, items:[{ h, id, t, u, img, p, at }] }
   API publique : window.BisouWishlist                              */
(function () {
  'use strict';

  var KEY = 'br_wishlist_v1';

  /* — Pont i18n : les libellés viennent de sections/header.liquid (le JS n'a pas accès à | t) — */
  var i18n = {};
  try { i18n = JSON.parse((document.getElementById('bisou-wishlist-i18n') || {}).textContent || '{}'); } catch (e) {}

  function read() {
    try {
      var d = JSON.parse(localStorage.getItem(KEY));
      return d && Array.isArray(d.items) ? d.items : [];
    } catch (e) { return []; }
  }

  function write(items) {
    try { localStorage.setItem(KEY, JSON.stringify({ v: 1, items: items })); } catch (e) {}
    document.dispatchEvent(new CustomEvent('bisou:wishlist', { detail: { count: items.length } }));
  }

  function has(handle) {
    return read().some(function (i) { return i.h === handle; });
  }

  function add(data) {
    if (!data || !data.h) return;
    var items = read();
    if (items.some(function (i) { return i.h === data.h; })) return;
    items.push(data);
    write(items);
  }

  function remove(handle) {
    write(read().filter(function (i) { return i.h !== handle; }));
  }

  function toggle(data) {
    if (has(data.h)) { remove(data.h); return false; }
    add(data); return true;
  }

  function count() { return read().length; }

  /* — Synchronisation visuelle — */

  function syncHearts(root) {
    var btns = (root || document).querySelectorAll('.bisou-wish-btn');
    for (var i = 0; i < btns.length; i++) {
      var btn = btns[i];
      var on = has(btn.getAttribute('data-handle'));
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute('aria-label', on ? (i18n.remove || 'Retirer de la liste de souhaits') : (i18n.add || 'Ajouter à la liste de souhaits'));
    }
  }

  function syncHeader() {
    var n = count();
    var bubbles = document.querySelectorAll('.bisou-wish-bubble');
    for (var i = 0; i < bubbles.length; i++) {
      bubbles[i].hidden = n === 0;
      var span = bubbles[i].querySelector('.bisou-wish-count');
      if (span) span.textContent = n > 99 ? '99' : String(n);
    }
  }

  function syncAll() { syncHearts(); syncHeader(); }

  /* — Clic cœur (délégué, capture : passe avant les liens de carte) — */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.bisou-wish-btn') : null;
    /* Fallback : si un lien étiré (carte produit) couvre le cœur malgré le
       z-index, on route le clic par les coordonnées. */
    if (!btn && typeof e.clientX === 'number' && e.target.closest) {
      var card = e.target.closest('.card-wrapper');
      if (card) {
        var hearts = card.querySelectorAll('.bisou-wish-btn');
        for (var i = 0; i < hearts.length; i++) {
          var r = hearts[i].getBoundingClientRect();
          if (
            r.width > 0 &&
            e.clientX >= r.left - 10 && e.clientX <= r.right + 10 &&
            e.clientY >= r.top - 10 && e.clientY <= r.bottom + 10
          ) { btn = hearts[i]; break; }
        }
      }
    }
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    toggle({
      h: btn.getAttribute('data-handle'),
      id: btn.getAttribute('data-product-id'),
      t: btn.getAttribute('data-title'),
      u: btn.getAttribute('data-url'),
      img: btn.getAttribute('data-image'),
      p: btn.getAttribute('data-price'),
      at: Date.now()
    });
    btn.classList.add('bisou-wish-pop');
    setTimeout(function () { btn.classList.remove('bisou-wish-pop'); }, 450);
    syncAll();
  }, true);

  /* — Autres onglets + contenus re-rendus en AJAX (filtres collection) — */

  window.addEventListener('storage', function (e) {
    if (e.key === KEY) syncAll();
  });

  /* Toute modif (clic ou API BisouWishlist.add/remove) → resync cœurs + bulle */
  document.addEventListener('bisou:wishlist', syncAll);

  var moTimer = null;
  var mo = new MutationObserver(function () {
    clearTimeout(moTimer);
    moTimer = setTimeout(syncAll, 120);
  });

  function boot() {
    syncAll();
    if (document.body) mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);

  window.BisouWishlist = {
    KEY: KEY,
    read: read,
    has: has,
    add: add,
    remove: remove,
    toggle: toggle,
    count: count,
    sync: syncAll
  };
})();
